/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import PropertyCard from 'material/embeds/propertycard/propertycard';
import Content from 'material/embeds/content/content_container';
import EmailCollectionProperties from 'pages/dashboard/embeds/management/addons/addontypes/emailcollection/emailcollectionproperties/emailcollectionproperties_container';
import ControllerContainer from 'pages/dashboard/embeds/management/customize/controllercontainer/controllercontainer';
import Embed from 'material/embeds/embed/embed_container';
import { Link, Button, TextField, Tip, SingleSelectDropDown
} from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/addons/addontypes/emailcollection/emailcollection_styles';



/* ========== ~~~~~~~~~~ ADD-ON TYPE EMAIL COLLECTION ~~~~~~~~~~ ========== */
const EmailCollection = props => {
    const handleQueuePosition = (num) => {
        props.setUniqueEmailCollectionProperty('queuePosition', Number(num))
    };
    const dropDownItems = (numItems) => {
        let items = [];
        let tempNum = 1;
        while(items.length < numItems){
            items.push({name: `${tempNum}`, value: `${tempNum}`});
            tempNum ++
        }
        return items;
    };
    const location = props.location === 'in-content' ? 'in-content' : 'rail';
    /* /////////////// RENDER \\\\\\\\\\\\\\\ */
    return(
        <div className={`emailcollection ${props.classes.emailcollection}`}>

            <div className={'addonheader'}>
                <Link
                    color={'primary'}
                    type={'action'}
                    text={!!props.contentUUID ? 'Close' :'Cancel'}
                    icon={'times-circle'}
                    action={props.close}
                />
                <h4>Creating User Email Page</h4>
                <Button
                    variant={'primary'}
                    type={'action'}
                    text={'Preview'}
                    disabled={false}
                    action={() => props.handlePreview('EMAIL_COLLECTION')}
                />
            </div>

            <div className={`emailcollectioncreation ${location}`}>
                <PropertyCard
                    title={'Formatting'}
                    properties={<EmailCollectionProperties/>}
                />
                <ControllerContainer name={'emailcollectioncontainer'}>
                    <Embed isEditable={true} processClick={null} >
                        <Content isEditable={true} type={'email'}/>
                    </Embed>
                </ControllerContainer>
            </div>
            <div className={'emailcollectionfooter'}>
               <div className={'queueposition'}>
                    <label>Set as card #</label>
                    <SingleSelectDropDown
                        name={'position'}
                        searchable={false}
                        selected={{value: `${props.queuePosition.value}`, name: `${props.queuePosition.value}`}}
                        items={dropDownItems(10)}
                        onSelect={num => handleQueuePosition(num.value)} />
                        <Tip
                            content={'We recommend to place the email collection card early in the content queue, where users are most engaged answering questions (users answer an average of 7–9 questions per session)'}/>
                </div>
            </div>
        </div>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmailCollection);
